/** Builder work steps: localized labels (keys come from backend builder/labels.py) and icons. */
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from './ui';

export function activityText(t, key, params, fallback) {
  if (key) return t(key, { ...(params || {}), defaultValue: fallback || t('agent_studio_working') });
  return fallback || t('agent_studio_working');
}

export const stepLabel = (t, data) => activityText(t, data.label_key, data.label_params, data.label);

export const stepDetail = (t, data) => (data.detail_key ? t(data.detail_key, { defaultValue: data.detail }) : data.detail);

export function StepIcon({ status }) {
  if (status === 'running') return <Spinner size={12} />;
  if (status === 'error') return <FontAwesomeIcon icon={faXmark} className="as-warn" />;
  return <FontAwesomeIcon icon={faCheck} className="as-step-done" />;
}

export function StepList({ items }) {
  const { t } = useTranslation();
  return (
    <ul className="as-activity-list">
      {items.map((i) => (
        <li key={i.id}>
          <StepIcon status={i.data.status} />
          <span>
            {stepLabel(t, i.data)}
            {i.data.detail && <span className="as-warn-text"> – {stepDetail(t, i.data)}</span>}
          </span>
        </li>
      ))}
    </ul>
  );
}
